import React from 'react';
import { AlertTriangle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../../../components/ui/Dialog';
import { Button } from '../../../components/ui/Button';
import type { Ticket } from '../../../core/models/Ticket';

interface TicketDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  ticket: Ticket;
  onConfirm: () => Promise<void>;
}

export const TicketDeleteDialog: React.FC<TicketDeleteDialogProps> = ({
  open,
  onClose,
  ticket,
  onConfirm,
}) => {
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error('Error deleting ticket:', error);
      alert('Failed to delete ticket. Please try again.');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-error" />
            Delete Ticket
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete ticket <strong>{ticket.key}</strong>?
            <br />
            <br />
            <strong>Summary:</strong> {ticket.summary}
            <br />
            <br />
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={handleConfirm} loading={isDeleting}>
            Delete Ticket
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
